export function formatNumber(number: number, locale = 'en-US'): string {
  const formatter = new Intl.NumberFormat(locale);

  return formatter.format(number);
}
